import type { editor } from 'monaco-editor';

export const editorOptions: editor.IEditorConstructionOptions = {
	renderLineHighlight: 'none',
	glyphMargin: false,
	lineNumbersMinChars: 0,
	overviewRulerBorder: false,
	overviewRulerLanes: 0,
	scrollBeyondLastLine: false,
	minimap: {
		enabled: false,
	},
	scrollbar: {
		horizontal: 'auto',
		vertical: 'auto',
		alwaysConsumeMouseWheel: false,
		verticalSliderSize: 4,
	},
};

export const sensitiveSQL = [
	'INSERT',
	'UPDATE',
	'DELETE',
	'ALTER',
	'DROP',
	'CREATE',
	'GRANT',
	'REVOKE',
];